<template>
    <div class="section" id="loader">
       <div id="preloader">
        <h1>loading</h1>
        <span id="loading"></span>

       </div>
 
    </div>
</template>
<script>
    export default {
        name:'Loader'
    }
</script>